module.exports = __webpack_public_path__ + "static/media/ChangePlanArrow.b1841a19.svg";